function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { isEqual } from 'lodash';
import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { createContainer } from 'unstated-next';
import { transformValue as originalTransformValue, flattenTree, reconcile, sortByTree, findNodeByValue } from './libs/utils';
import { All } from './constants';

var useCascade = function useCascade(params) {
  var _ref = params || {},
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$value = _ref.value,
      valueProp = _ref$value === void 0 ? [] : _ref$value,
      selectAll = _ref.selectAll,
      selectAllDisabled = _ref.selectAllDisabled,
      onChange = _ref.onChange,
      onCascaderChange = _ref.onCascaderChange,
      selectLeafOnly = _ref.selectLeafOnly,
      renderNodeTitle = _ref.renderNodeTitle,
      _ref$isLiftTree = _ref.isLiftTree,
      isLiftTree = _ref$isLiftTree === void 0 ? true : _ref$isLiftTree;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      popupVisible = _useState2[0],
      setPopupVisible = _useState2[1];

  var dataRef = useRef(data);
  useEffect(function () {
    dataRef.current = data;
  }, [data]);

  var _useState3 = useState(function () {
    if (selectAll) {
      return flattenTree([{
        title: 'All',
        value: All,
        parent: null,
        children: data
      }]);
    }

    return flattenTree(data);
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      flattenData = _useState4[0],
      setFlattenData = _useState4[1];

  useEffect(function () {
    setFlattenData(function () {
      if (selectAll) {
        return flattenTree([{
          title: 'All',
          value: All,
          parent: null,
          children: data
        }]);
      }

      return flattenTree(data || []);
    });
  }, [data, selectAll]);
  var selectedItems = useMemo(function () {
    // const values = matchAllLeafValue(valueProp, flattenData)
    return flattenData.filter(function (node) {
      return valueProp.includes(node.value);
    });
  }, [flattenData, valueProp]);
  var transformValue = useCallback(function (v) {
    var nextValue = originalTransformValue(v, flattenData, isLiftTree);

    if (onChange && !isEqual(nextValue, v)) {
      requestAnimationFrame(function () {
        return onChange(nextValue, selectedItems);
      });
    }

    return nextValue;
  }, [flattenData, selectedItems]);

  var _useState5 = useState([selectAll ? flattenData[0].children : flattenData.filter(function (item) {
    return !item.parent;
  })]),
      _useState6 = _slicedToArray(_useState5, 2),
      menuData = _useState6[0],
      setMenuData = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      menuPath = _useState8[0],
      setMenuPath = _useState8[1];

  var _useState9 = useState(transformValue(valueProp)),
      _useState10 = _slicedToArray(_useState9, 2),
      value = _useState10[0],
      setValue = _useState10[1];

  var addMenu = useCallback(function (menu, index, isLeaf) {
    if (menu && menu.length) {
      setMenuData(function (prevMenuData) {
        return [].concat(_toConsumableArray(prevMenuData.slice(0, index)), [menu]);
      });
    } else if (isLeaf === false) {
      setMenuData(function (prevMenuData) {
        return [].concat(_toConsumableArray(prevMenuData.slice(0, index)), [menu ? [] : null]);
      });
    } else {
      setMenuData(function (prevMenuData) {
        return _toConsumableArray(prevMenuData.slice(0, index));
      });
    }
  }, []);
  var addChildrenToNode = useCallback(function (target, children) {
    var targetValue = target.value;
    var found = findNodeByValue(targetValue, dataRef.current);

    if (found) {
      found.children = children;
    }

    return _toConsumableArray(dataRef.current);
  }, []);
  var lastItemRef = useRef(null);
  var handleCascaderChange = useCallback(function (item, depth) {
    var isTrusted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var children = item.children;

    if (isTrusted) {
      lastItemRef.current = item;
      onCascaderChange === null || onCascaderChange === void 0 ? void 0 : onCascaderChange(item, {
        add: function add(newChildren) {
          var newData = addChildrenToNode(item, newChildren);

          if (lastItemRef.current === item) {
            // eslint-disable-next-line no-param-reassign
            item.children = newChildren;
            newChildren.forEach(function (child) {
              // eslint-disable-next-line no-param-reassign
              child.parent = item;
            });
            setFlattenData(function (prev) {
              return [].concat(_toConsumableArray(prev), _toConsumableArray(newChildren));
            }); // 拉取到数据之后再触发一次更新 menu

            handleCascaderChange(item, depth, false);
          }

          return newData;
        }
      });
    }

    addMenu(children, depth + 1, item.isLeaf);
    setMenuPath(function (prevMenuPath) {
      return prevMenuPath.slice(0, depth).concat(item);
    });
  }, [menuPath, onCascaderChange]);
  var handleSelectChange = useCallback(function (item, checked) {
    setValue(function (prevValue) {
      return sortByTree(reconcile(item, checked, prevValue, isLiftTree), flattenData);
    });
  }, [flattenData]);
  var resetMenuState = useCallback(function () {
    setMenuData([selectAll ? flattenData[0].children : flattenData.filter(function (item) {
      return !item.parent;
    })]);
    setMenuPath([]);
  }, [flattenData, selectAll]); // 传入的 value 有变更时重新计算

  useEffect(function () {
    if (popupVisible) {
      setValue(transformValue(valueProp));
      resetMenuState();
    }
  }, [popupVisible]);
  return {
    menuPath: menuPath,
    popupVisible: popupVisible,
    setPopupVisible: setPopupVisible,
    menuData: menuData,
    addMenu: addMenu,
    setMenuData: setMenuData,
    value: value,
    setValue: setValue,
    handleCascaderChange: handleCascaderChange,
    handleSelectChange: handleSelectChange,
    flattenData: flattenData,
    resetMenuState: resetMenuState,
    selectedItems: selectedItems,
    selectLeafOnly: selectLeafOnly,
    renderNodeTitle: renderNodeTitle,
    selectAllDisabled: selectAllDisabled
  };
};

export default createContainer(useCascade);

function requestAnimationFrame(arg0) {
  throw new Error('Function not implemented.');
}